import { LoadablePaint } from '@confluence/loadable';

export { SpaceBlogs } from './SpaceBlogs';

export const SpaceBlogsLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-space-blogs" */ './SpaceBlogs')).SpaceBlogs,
});
